// Copyright (c) 2019-2023 Cigent Technology Inc. All Rights Reserved.
import { Component, Inject } from '@angular/core';
import { MAT_BOTTOM_SHEET_DATA } from '@angular/material/bottom-sheet';

@Component({
    selector: 'app-protection-level-bottom-sheet',
    templateUrl: './protection-level-bottom-sheet.component.html',
    styleUrls: ['./protection-level-bottom-sheet.component.scss'],
    standalone: false
})
export class ProtectionLevelBottomSheetComponent {
    topicDescription: string;
    sheetType: 'protection' | 'encryption';

    constructor(@Inject(MAT_BOTTOM_SHEET_DATA) public data: any) {
        // ex: 'files with this extension' or 'files within this folder'
        this.topicDescription = data.topicDescription || '';
        this.sheetType = data.sheetType || 'protection';

    }


}
